export default {
  backgroundColor: {
    'ui:widget': 'BaseColorWidget',
  },
  borderColor: {
    'ui:widget': 'BaseColorWidget',
  },
  items: {
    items: {
      textColor: {
        'ui:widget': 'BaseColorWidget',
      },
      leftImage: {
        'ui:widget': 'EditorUploadWidget',
      },
      rightImage: {
        'ui:widget': 'EditorUploadWidget',
      },
      targetType: {
        'ui:widget': 'RadioWidget',
      },
      blockHash: {
        'ui:widget': 'EditorBlockListWidget',
      },
    },
  },
}
